<template>
  <div class="active-appointments-table">
    <v-client-table
      id="activeAppointmentsTable"
      ref="activeAppointmentsTable"
      name="activeAppointmentsTable"
      :data="activeAppointments"
      :columns="columns"
      :options="tableOptions"
      @row-click="click => handleAppointmentClick(click.row)"
      >

      <span slot="h__has_reason"></span>
      <span v-if="row.status !== null && row.ended_at !== null" slot="has_reason" slot-scope="{ row }">
        <i class="fa fa-lock"></i>
      </span>
      <span slot="time" slot-scope="{row}">
        {{row.start | localTime('DD-MM-YYYY')}} ({{row.start | localTime('HH:mm')}} - {{row.end | localTime('HH:mm')}})
      </span>

      <span slot="started_at" slot-scope="{row}">
        {{row.started_at | localTime('DD-MM-YYYY HH:mm')}}
      </span>

      <span slot="facility_name" slot-scope="{row}">
        <span v-if="row.facility">
          {{row.facility.name}}
        </span>
      </span>

      <span slot="type" slot-scope="{row}">
        <span v-if="row.type">
          {{`${row.type.name} - ${row.type.slug}`}}
        </span>
      </span>

      <span slot="person_name" slot-scope="{row}">
        {{row.person.name}}
      </span>

      <span slot="person_process_id" slot-scope="{row}">
        {{row.person.process_id}}
      </span>

      <span slot="person_birthdate" slot-scope="{row}">
        {{row.person.birthdate | localTime('DD-MM-YYYY', "N/A")}}
      </span>

    </v-client-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { ClientTable } from 'vue-tables-2'
Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  computed: {
    waitingRoomModuleKey: function () {
      return `waiting-room-${this.serviceSlug}`
    },
    ...mapState({
      activeAppointments (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeAppointments`] || []
      }
    }),
  },
  data: function () {
    return {
      columns: ['has_reason', 'time', 'started_at', 'facility_name', 'type', 'person_name', 'person_process_id', 'person_birthdate'],
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns')
        },
        headings: {
          time: this.$t('clinical.appointments.appointment_date'),
          started_at: this.$t('clinical.appointments.appointment_started_at'),
          facility_name: this.$t('clinical.appointments.facility'),
          type: this.$t('clinical.appointments.type'),
          person_name: this.$t('clinical.people.name'),
          person_process_id: this.$t('clinical.people.client_nr'),
          person_birthdate: this.$t('clinical.people.birthday')
        },
        column_classes: {
          has_reason: 'has_reason'
        },
        skin: 'table table-striped table-hover is-fullwidth',
        sortable: ['time', 'facility_name'],
        sortIcon: {
          is: 'fa-sort',
          base: 'fa fa-fw',
          up: 'fa-sort-up',
          down: 'fa-sort-down'
        },
        columnsDropdown: false,
        pagination: {
          chunk: 4,
          nav: 'scroll'
        }
      },
    }
  },

  methods: {
    handleAppointmentClick: function (appointment) {
      this.$router.push(
        {
          name: `${this.serviceSlug}clinical/appointments/:id/anamnesis/edit`,
          params: { id: appointment.id }
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">

</style>
